import { contractState } from '../../model/details/contract';

// Types
import { LeadDetailRawType } from '../../types/Lead';

export default function transformContractState(data: LeadDetailRawType) {
    const map = new Map();
    let _transform = {};

    map.set('contractDetails.duration', 'duration');
    map.set('contractDetails.mileage', 'mileage');
    map.set('contractDetails.publicationId', 'publicationId');
    map.set('contractDetails.totalRate.gross', 'rateGross');
    map.set('contractDetails.totalRate.net', 'rateNet');
    map.set('contractDetails.totalPrice.gross', 'totalPriceGross');
    map.set('contractDetails.totalPrice.net', 'totalPriceNet');
    map.set('contractDetails.campaignTitle', 'campaignTitle');
    map.set('contractDetails.publicationTitle', 'category');
    map.set('externalReferences.leasmanMasterContractId', 'leasmanMasterId');
    map.set('externalReferences.leasmanContractId', 'leasmanContractId');

    map.forEach((uiKey, apiKey) => {
        const [type, subKey, subKeyType] = apiKey.split('.');
        const [pType, pSubKey] = uiKey.split('.');
        let _val;

        // 3. rank : 3 keys like energyInfo.wltpInfo.co2EmissionCombined
        if (subKeyType && subKey && data[type][subKey]) {
            const _v = data[type][subKey][subKeyType];

            _val = _v === null ? contractState[pType][pSubKey] : data[type][subKey][subKeyType];
        }
        // 2. rank : 2 keys like energyInfo.nefzIsEmpty
        else if (subKey && data[type]) {
            _val = data[type][subKey];
        }
        // 1. rank : standard
        else {
            _val = data[apiKey] === null || data[apiKey] === undefined ? contractState[uiKey] : data[apiKey];
        }

        _transform = {
            ..._transform,
            [uiKey]: _val === null || _val === undefined ? contractState[uiKey] : _val,
        };
    });

    return _transform;
}
